import { Modal, ModalFooter, ModalBody, ModalHeader, MODAL_SIZES, MODAL_VARIANTS } from 'ui/modal';
import { BUTTON_SIZES, PrimaryButton } from 'ui/button';
import { PredictiveAudienceGoal } from '../../types';
import { ModalText, StyledMonospace } from '../Styled';

export type EditModalProps = {
  /** Header text for edit modal. */
  goal: PredictiveAudienceGoal;
  /** Callback function to edit modal when close is click. */
  onClose: () => void;
  /** Callback function to edit modal when confirm is click. */
  editGoal: () => void;
  /* Used for accessibility attributes, and not visual control */
  isModalOpen: boolean;
};

export const EditModal = ({ editGoal, goal, isModalOpen, onClose }: EditModalProps) => {
  return (
    <Modal
      id={'editGoalModal'}
      isModalOpen={isModalOpen}
      onClose={onClose}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.WARNING}
    >
      <ModalHeader>Update goal?</ModalHeader>
      <ModalBody>
        <ModalText>
          Heads up! This can take a while (no more than 24 hours) to re-create your predictive goal
          and calculate a new conversion probability for your contacts.
        </ModalText>
        <ModalText>
          Changes in your goal criteria may impact your existing workflows, lists, and campaigns
          that uses
          <StyledMonospace>{goal.userProfileField}</StyledMonospace>.
        </ModalText>
      </ModalBody>
      <ModalFooter>
        <PrimaryButton onClick={editGoal} size={BUTTON_SIZES.LARGE}>
          Update goal
        </PrimaryButton>
      </ModalFooter>
    </Modal>
  );
};

export default EditModal;
